import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function RoleLogin() {
  const apiURL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [userRoles, setUserRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) navigate("/");
  }, [navigate]);

  useEffect(() => {
    console.log("Loading state changed:", loading);
  }, [loading]);

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      setTimeout(() => setLoading(false), 100);
      return;
    }

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${apiURL}/UserRole/Get?userId=${userId}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.status && response.data.data) {
          setUserRoles(response.data.data.filter((role) => role.isVisible));
        }
      })
      .catch((error) => {
        console.error("Error fetching roles:", error);
      })
      .finally(() => {
        setTimeout(() => setLoading(false), 100);
      });
  }, []);

  const handleRoleSelection = (type) => {
    const rolePaths = {
      Admin: "/admin-dashboard",
      MandalAdmin: "/mandal-admin-dashboard",
      MandalSubAdmin: "/mandal-subadmin-dashboard",
      SamparkAdmin: "/sampark-admin-dashboard",
      AttendanceWorker: "/attendance-worker-dashboard",
    };

    localStorage.setItem("roles", type);
    navigate(rolePaths[type] || "/");
  };

  return (
    <div>
      <div>
        <div className="starsec"></div>
        <div className="starthird"></div>
        <div className="starfourth"></div>
        <div className="starfifth"></div>
      </div>
      <div className="login-page" id="page-bg">
        <div className="d-flex justify-content-center align-items-center">
          <div
            className="bg-white shadow-lg rounded p-4 w-75 text-center"
            style={{ maxWidth: "350px" }}
          >
            <h2 className="mb-4">Select Your Role</h2>
            <div className="d-grid gap-3">
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm "
                    role="status"
                    aria-hidden="true"
                  ></span>
                </>
              ) : (
                <>
                  {userRoles.map((role, index) => (
                    <button
                      key={index}
                      onClick={() => handleRoleSelection(role.type)}
                      className="btn btn-primary w-100 mb-3"
                    >
                      {role.type}
                    </button>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
